import { CommonEditForm } from './CommonEditForm';
import { PhoneSectionInForm } from './PhoneSectionInForm';
export const NormalEditForm = () => {
  return <>
      <CommonEditForm data-sentry-element="CommonEditForm" data-sentry-source-file="NormalEditForm.tsx" />
      <PhoneSectionInForm type="normal" data-sentry-element="PhoneSectionInForm" data-sentry-source-file="NormalEditForm.tsx" />
    </>;
};